module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/carousel_tiktok_tablet_01@2x-252b01644e160c0dfc78bbbbd0606375.jpg";